module.exports = __webpack_public_path__ + "static/media/MyriadPro-Regular.126f1284.svg";